import React from "react";
// import { useImmer } from "use-immer";
// import axios from "axios";
// import ReactMarkdown from "react-markdown";

export const GptChat = () => {
  // const [data, setData] = useImmer({
  //   chat: [],
  //   input: "",
  //   sessionId: "",
  // });
  // const API = axios.create({
  //   baseURL: "http://172.174.128.98:8000/",
  //   headers: {
  //     "Content-Type": "application/json",
  //     Accept: "application/json",
  //   },
  // });
  // const invokeApi = async (payload) => {
  //   const res = await API.post(`chat`, payload);
  //   return res;
  // };
  // const sendMessage = async (input) => {
  //   try {
  //     setData((draft) => {
  //       draft.chat = [
  //         ...draft.chat,
  //         { question: draft.input, answer: "", isLoading: true },
  //       ];
  //       draft.input = "";
  //     });
  //     let payload = {
  //       question: input,
  //     };
  //     if (data.sessionId) {
  //       payload = { ...payload, session_id: data.sessionId };
  //     }
  //     const res = await invokeApi(payload);
  //     console.log("res", res);
  //     if (res.status === 200) {
  //       setData((draft) => {
  //         draft.chat[draft.chat.length - 1].answer = res.data.answer;
  //         draft.chat[draft.chat.length - 1].isLoading = false;
  //         draft.sessionId = res.data.session_id;
  //       });
  //     }
  //   } catch (err) {
  //     console.log("err", err);
  //   }
  // };
  return (
    // <div className="chat-container">
    //   <div className="chat-history">
    //     <h2>Chat History</h2>
    //     <ul>
    //       <li>Conversation 1</li>
    //     </ul>
    //   </div>
    //   <div className="chat">
    //     <div className="messages">
    //       {data.chat.map((item) => {
    //         return (
    //           <>
    //             <div className="message user">{item.question}</div>
    //             {item.isLoading ? (
    //               <div>...loading</div>
    //             ) : (
    //               <div className="message bot">
    //                 <ReactMarkdown>{item.answer}</ReactMarkdown>
    //               </div>
    //             )}
    //           </>
    //         );
    //       })}
    //     </div>
    //     <form
    //       onSubmit={(e) => {
    //         e.preventDefault();
    //         sendMessage(data.input);
    //       }}
    //       className="input-container"
    //     >
    //       <input
    //         value={data.input}
    //         onChange={(e) => {
    //           setData((draft) => {
    //             draft.input = e.target.value;
    //           });
    //         }}
    //         type="text"
    //         placeholder="Type a message..."
    //       />
    //       <button>Send</button>
    //     </form>
    //   </div>
    // </div>
    <></>
  );
};
